import {
  isIos,
  isStandalone,
  isCypress,
  isAppStore,
  isAndroid
} from "@/lib/is-platform"
import { isEmpty, isPresent } from "@/lib/utils"

export default {
  namespaced: true,

  state: {
    installPrompt: null,
    hasDownloaded: false,
    isDownloadBarShowing: false
  },

  mutations: {
    setInstallPrompt(state, prompt) {
      state.installPrompt = prompt
    },

    setHasDownloaded(state) {
      state.hasDownloaded = true
    },

    setDownloadBarShowing(state, isShowing) {
      state.isDownloadBarShowing = isShowing
    }
  },

  actions: {
    setupInstallPrompt({ commit }) {
      window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault()
        commit("setInstallPrompt", e)
      })
    },

    trackDownloadActivity({ dispatch }, { activityType, context }) {
      dispatch(
        "analytics/trackActivity",
        { activityType, data: { context } },
        { root: true }
      )
    },

    triggerInstallPrompt({ state, commit, dispatch }, context) {
      const { installPrompt } = state

      if (!installPrompt) return

      installPrompt.prompt()

      return installPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === "accepted") {
          dispatch("trackDownloadActivity", {
            activityType: "app_downloaded",
            context
          })
          commit("setHasDownloaded")
        } else {
          dispatch("trackDownloadActivity", {
            activityType: "app_download_aborted",
            context
          })
        }

        commit("setInstallPrompt", null)
      })
    },

    addToHomescreen({ dispatch }, { context, triggerInstall = false }) {
      dispatch("trackDownloadActivity", {
        activityType: "app_download_started",
        context
      })

      if (triggerInstall) {
        dispatch("triggerInstallPrompt", context)
      }
    }
  },

  getters: {
    canPrompt(state, _, rootState) {
      if (state.hasDownloaded) {
        return false
      } else if (isCypress()) {
        return isPresent(window.canDownload) ? window.canDownload : false
      } else if (isAppStore()) {
        return false
      } else if (isEmpty(rootState.global?.app.icon)) {
        return false
      } else if (isIos() && !isStandalone()) {
        return true
      } else if (!isStandalone() && !!state.installPrompt) {
        return true
      } else if (isAndroid() && !isStandalone()) {
        return true
      } else {
        return false
      }
    }
  }
}
